import React, {useEffect, useState, useRef} from "react";
import * as faceapi from 'face-api.js';
import Toast from "../../../lib/toast";
import { getAuth, GoogleAuthProvider,RecaptchaVerifier,signInWithPhoneNumber } from "firebase/auth";
import { markWorkoutPlusAttendance, markWorkoutplusPTAttendance } from "../../../components/helper/api";
import { isAuthenticated } from "../../../auth";
import { startLoader, stopLoader } from "../../../lib/utils";
import * as config from '../../../config';
import { app } from "../../../lib/firebase-config";

const provider = new GoogleAuthProvider();
const auth = getAuth(app);

let setTimer=null;
let blobData=null;

const Attendance = (props) => {

  const videoRef = useRef();
  const {user, token} = isAuthenticated();
  const container = useRef(null);
  const [isButtonLock,setButtonLock] = useState(false);
  const [Member,setMember] =useState("");
  const [memberImageSrc, setMemberImageSrc] = useState(null);
  const [isOTPsent, OTPSent] = useState(false);

  // Face Scan Progress
  const radius = 320 / 2 - 5;
  const strokeWidth = 6;
  const viewBoxSize = 320 + strokeWidth;
  const circumference = 2 * Math.PI * radius;
  const [progressOffset, setProgressOffset] = useState(circumference - ((0 * 100) / 100) * circumference);
  const [isCaptureImageOpen, setCaptureImageOpen] = useState(false);

  const displayNumberWithStar = (phone) =>{
    if(phone.length==12){
        phone = phone.substring(2,phone.length);
    } else if(phone.length==13){
        phone = phone.substring(3,phone.length);
    }

    return `${phone[0]}${phone[1]}******${phone[phone.length-2]}${phone[phone.length-1]}`
  }  

  const loadModels = ()=>{
   try{
    Promise.all([
      // THIS FOR FACE DETECT AND LOAD FROM YOU PUBLIC/MODELS DIRECTORY
      faceapi.nets.tinyFaceDetector.loadFromUri("/models"),
      faceapi.nets.faceLandmark68Net.loadFromUri("/models"),
      faceapi.nets.faceRecognitionNet.loadFromUri("/models"),
      faceapi.nets.faceExpressionNet.loadFromUri("/models")

      ]).then(()=>{
      detectMyFace()
    }).catch(err => { console.error(err); return { error: true, message: err?.message }; })
   }catch(error){

   }
  }

  const detectMyFace = ()=>{
   try{
    setInterval(async()=>{
     if(videoRef.current){
        try{
          let detections = await faceapi.detectAllFaces(videoRef.current, new faceapi.TinyFaceDetectorOptions()).withFaceLandmarks().withFaceExpressions();
          let canvas = faceapi.createCanvasFromMedia(videoRef.current);
      
          if(canvas && (detections && detections.length)){
          
                faceapi.matchDimensions(canvas,{
                  width:280,
                  height:280
                })
          
                if(detections && detections.length > 0 && detections[0].expressions){
                  setTimeout(() => {
                    setProgressOffset(circumference - ((detections[0].expressions.neutral.toFixed(2) * 100) / 100) * circumference);
                  }, 1000);
                }
          
                if(detections && detections.length > 0 && detections[0].expressions && detections[0].expressions.neutral > 0.80){             
                  captureImage(canvas);
                  setTimeout(() => {
                    stopVideo();
                  }, 2000);
                }
        }
        }catch(error){
          alert(error)
        }
     }
     },1000);
   }catch(error){
    alert(error)
   }
  }

  const sendOtp = async () => {
    try {
      const container=document.getElementById("recaptcha-container");
      if(container) container.remove();
      const div=document.createElement('div');
      div.id="recaptcha-container";
      document.body.append(div);
      if(window.recaptchaVerifier) window.recaptchaVerifier.clear();
      window.recaptchaVerifier = new RecaptchaVerifier(document.getElementById('recaptcha-container'), {
        size: 'invisible',
        callback: () => {
            console.log('recaptcha resolved..')
        },
        'expired-callback': () => {
        }
      },auth);

      if(!setTimer){
        var elem = document.getElementById('some_div');
        elem.style.display='block';
        let timeLeft=30;
        setTimer=setInterval(()=>{
          if (timeLeft == -1) {
            clearInterval(setTimer);
            setTimer=null;
            elem.style.display='none';
          } else {
            if(elem) elem.innerHTML = "( 00:"+timeLeft.toString().padStart(2,"0")+" )";
            timeLeft--;
          }
        },1000);
        let phone="";
        if(Member.userInfo.phone.length==10){
            phone =Member.userInfo.phone;
        }else if(Member.userInfo.phone.length==12){
            phone = Member.userInfo.phone.substring(2,Member.userInfo.phone.length);
        } else if(Member.userInfo.phone.length==13){
            phone = Member.userInfo.phone.substring(3,Member.userInfo.phone.length);
        }

        phone = "7003737337";

        signInWithPhoneNumber(auth,"+91"+phone, window.recaptchaVerifier).then((result) => {  
          window.result=result;
          new Toast({
            type:"success",
            message:"OTP send to +91"+phone,
            duration:2000
          });
        }).catch((err) => {
          new Toast({
            type:"error",
            message:"Can't send otp please wait",
            duration:2000
          });
          console.log(err )
        });
      }else{
        new Toast({
          type:"error",
          message:"Can't send otp please wait",
          duration:2000
        });
      }

    
    } catch (error) {
        //flag = false
        console.log('error sending otp ' + error)
    }
}

  
  const captureImage = (canvas) => {
    const ctx = canvas.getContext('2d');        
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;        
    ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);  

    canvas.toBlob((blob) => {
      if (blob) {
        blobData = blob;
        const url = URL.createObjectURL(blob);
        setMemberImageSrc(url);
      }
    }, 'image/png'); 
  };

  const startVideo = async ()=>{
    setCaptureImageOpen(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: { exact: "environment" } }
      });

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        loadModels();
      }
    } catch (error) {
        console.error('Error accessing camera:', error);

        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "user" },
          });
    
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            loadModels();
          }
        } catch (fallbackError) {
          console.error('Error accessing front camera:', fallbackError);
        }
    }
  }


  const stopVideo = () => {
    try{
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    }catch(error){

    }
  };

  const MarkWorkoutPlusAttendance = async () =>{
    try{
      await startLoader()
      setButtonLock(true);
      const payload=new FormData()
      if(props.type == "Gym Attendance") payload.set("memberId",Member._id);
      if(memberImageSrc){
        payload.set("photo",blobData);
      }
      const response = props.type == "Gym Attendance" ? await markWorkoutPlusAttendance(user._id,token,payload) :  await markWorkoutplusPTAttendance(user._id,token,Member.branchId,Member._id,payload);
      
      console.log(response);

      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        });
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Attendance marked successfully"
        });
      }

      stopVideo();
      await stopLoader()
      setButtonLock(false)
      if(props.closeMemberAttendance) props.closeMemberAttendance()
    }catch(error){
      alert(error)
      new Toast({
        type:"error",
        duration:3000,
        message:"Something went wrong, unable to mark the attendance"
      });
      await stopLoader()
      setButtonLock(false)
    }
  }

  const handleSendOTP = () => {

    //test
    MarkWorkoutPlusAttendance();
    return;
    //test

    OTPSent(!isOTPsent);
  }

  useEffect(()=>{
    if(props.member) setMember(props.member.current);
  },[props]);


  const inputRefs = useRef([]);
  const [otpValue, setOtpValue] = useState('');


  const setRef = (element, index) => {
    inputRefs.current[index] = element;
  };

  const handleOTP = (e, index) => {
    const { value } = e.target;
    if (value.length > 1) return;

    const newOtpValue = otpValue.split('');
    newOtpValue[index] = value;
    setOtpValue(newOtpValue.join(''));

    if (value.length === 1 && index < 5) {
      // Move to the next field
      inputRefs.current[index + 1].focus();
    } else if (value.length === 0 && index > 0) {
      // Move to the previous field
      inputRefs.current[index - 1].focus();
    }
  };


  const verifyOtp=() =>{
  try{
    setButtonLock(true);
    startLoader();
    // MarkWorkoutPlusAttendance();
    if(window.result){
      window.result.confirm(otpValue).then((result) => {
        const user = result.user;
        MarkWorkoutPlusAttendance();
      }).catch((error) => {
       stopLoader();
       setButtonLock(false);
       new Toast({
        type:"error",
        message:"Unable to login try after sometime",
        duration:1000
       });
      });
    }else{
      stopLoader();
      setButtonLock(true);
    }
  }catch(error){
    stopLoader();
    setButtonLock(true);
  }
  }

  useEffect(()=>{
    try{
      if(isOTPsent){
        setTimeout(()=>{
          sendOtp();
        },700);
      }
    }catch(error){
      console.log(error)
    }
  },[isOTPsent])

  // useEffect(()=>{
  //   try{
  //     if(props.type == "PT Attendance"){
  //       if(otpValue.length == 6){
  //         setButtonLock(false)
  //       }else{
  //         setButtonLock(true);
  //       }
  //     }
  //   }catch(error){
  //     console.error(error)
  //   }
  //   setButtonLock(false)
  // },[otpValue]);

  return(
    // attendance-modal-container
    <div className="w-full h-full">
      {/* <div className="d-flex space-between p-t-20 p-r-20 p-l-20">
        <svg onClick={()=> {stopVideo(); props.closeMemberAttendance()}} className="flex-item" width="24" height="24" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7L18 9ZM0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM18 7L1 7L1 9L18 9L18 7Z" fill="#6d6d6d"/>
        </svg>
        <p className="flex-item fs-24 color-black font-weight-600" style={{lineHeight:"24px"}}>{props.type == "PT Attendance" && "PT"} Attendance</p>
        <svg className="flex-item" style={{visibility:"hidden"}} width="19" height="8" viewBox="0 0 19 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 4.5C18.2761 4.5 18.5 4.27614 18.5 4C18.5 3.72386 18.2761 3.5 18 3.5L18 4.5ZM0.646447 3.64645C0.451184 3.84171 0.451184 4.15829 0.646447 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646447 3.64645ZM18 3.5L1 3.5L1 4.5L18 4.5L18 3.5Z" fill="black"/>
        </svg>
      </div> */}
      <div className="flex-item margin-auto user-attendance-details m-t-40">
        {
            Member && Member.userInfo.logoFileID ? (
              <div className="user-img d-flex margin-auto m-b-12">
                <img src={`${config.API_URL}/image/file/${Member.userInfo.logoFileID}/auto/auto/70`} />
              </div>
            ) : (
              <div className="user-img d-flex margin-auto m-b-12">
                <p className="flex-item" style={{ margin: "0 auto", color: '#ffffff' }}>{`${Member && Member.userInfo.name}`.trim()[0]}</p>
              </div>
            )
        }
        <p className="margin-auto fs-18 font-weight-400">{Member && Member.userInfo.name}</p>
        <p className="margin-auto fs-14 font-weight-300">{Member && Member.gym && Member.branch[0].name} ( {Member && Member.gym && Member.branch[0].address} )</p>
      </div>
      <div className="attendance-modal">
        <div className='d-flex w-full'>
          {
            isCaptureImageOpen ? (
              <div className="registration-qr-scanner d-flex fadeIn">
                <video id="face-detector" crossOrigin="anonymous" className="flex-item" width="170" height="170" style={{margin: "0 auto", background:"#000000", borderRadius: "100%"}} ref={videoRef} autoPlay />
                {
                  memberImageSrc && (
                    <img className="detected-face-img" src={memberImageSrc} />
                  )
                }
                <svg className="circular-progress" width={200} height={200} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
                  <circle
                    className="progress-background"
                    cx={viewBoxSize / 2}
                    cy={viewBoxSize / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                  />
                  <circle
                    className="progress-bar"
                    cx={viewBoxSize / 2}
                    cy={viewBoxSize / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={progressOffset}
                  />
                </svg>
                {/* <div style={{width:"500px", height:"500px", position:"absolute", margin: "-135px 0 0 -100px",backgroundColor:'red'}} ref={container} /> */}
              </div>
            ) : (
              <div onClick={()=> startVideo()} className="registration-qr-scanner d-flex fadeIn">
                <div className="detected-face-img" style={{background: "#D9D9D9", justifyContent:"center", textAlign:"center"}}>
                  <svg className="margin-auto m-t-16" width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.33333V5.66667C5 5.22464 5.17559 4.80072 5.48816 4.48816C5.80072 4.17559 6.22464 4 6.66667 4H8.33333M16.6667 4H18.3333C18.7754 4 19.1993 4.17559 19.5118 4.48816C19.8244 4.80072 20 5.22464 20 5.66667V7.33333M20 15.6667V17.3333C20 17.7754 19.8244 18.1993 19.5118 18.5118C19.1993 18.8244 18.7754 19 18.3333 19H16.6667M8.33333 19H6.66667C6.22464 19 5.80072 18.8244 5.48816 18.5118C5.17559 18.1993 5 17.7754 5 17.3333V15.6667M9.16667 13.1667C9.16667 13.1667 10.4167 14.8333 12.5 14.8333C14.5833 14.8333 15.8333 13.1667 15.8333 13.1667M10 9H10.0083M15 9H15.0083" stroke="#000000" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <p className="flex-item margin-auto color-black fs-16 font-weight-300" style={{lineHeight:"20px"}}>Capture<br/>Live Picture</p>
                </div>
              </div>
            )
          }
        </div> 
        {/* { 
          props.type == "PT Attendance" && [
        //     !isOTPsent ? (
        //       <div onClick={()=>handleSendOTP()} className="member-button-global btn-center w-full d-flex flex-item bg-dark-blue fadeIn m-t-6 p-t-20 p-b-20" style={{transition:"180ms", borderRadius:""}}>
        //         <p className='flex-item p-l-12 p-r-12' style={{color:"#ffffff"}}>Verify with OTP</p>
        //       </div>
        //     ) : (
        //       <div className="w-full m-t-20">
        //         <div className="d-flex w-full" style={{margin:"auto"}}>
        //           <p className="margin-auto color-red font-weight-500 fs-16">6 digit code sent to +91 {displayNumberWithStar(Member.userInfo.phone)}</p>
        //         </div>
        //         <div className="d-flex">
        //           <div className="otp-container flex-item" style={{margin:"8px auto 16px auto"}}>
        //             {[0, 1, 2, 3, 4,5].map((i) => (
        //               <input
        //                 className="otp-input"
        //                 key={i}
        //                 style={{margin:'0 4px'}}
        //                 ref={(el) => setRef(el, i)}
        //                 type="text"
        //                 maxLength="1"
        //                 onChange={(e) => handleOTP(e, i)}
        //                 onFocus={(e) => e.target.select()}
        //               />
        //             ))}
        //           </div>
        //         </div>
        //         <div style={{marginBottom:0,marginTop:4,display:'flex'}} className="space-between">
        //             <div onClick={sendOtp} style={{cursor:'pointer'}} className='forgot-email-pswd-txt'>Resend Code</div>
        //             <div id='some_div' style={{marginRight:8,color:'#000'}} className='forgot-email-pswd-txt'>00</div> 
        //           </div>
        //       </div>
        //      ) 
        //   ]
        // } */}
        <div className="face-attendance-footer w-full">
          {/* {
            memberImageSrc && (
              <div className="face-footer d-flex margin-auto fadeIn" style={{transition:"180ms"}}>
                <svg className="m-r-8" width="26" height="26" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="11" fill="#0092D6"/>
                  <path d="M11.1255 13.1591V10.173M16.0626 10.7188C16.0634 11.3711 15.9355 12.0172 15.6862 12.6201C15.4368 13.2229 15.071 13.7706 14.6096 14.2318C14.1479 14.6935 13.5998 15.0598 12.9966 15.3095C12.3933 15.5593 11.7467 15.6878 11.0938 15.6875C10.3911 15.6891 9.69615 15.5407 9.0553 15.2524L6.97809 15.5597C6.87496 15.5765 6.76927 15.5679 6.67021 15.5346C6.57115 15.5013 6.48171 15.4444 6.40967 15.3687C6.33763 15.293 6.28515 15.2008 6.25681 15.1003C6.22846 14.9997 6.2251 14.8937 6.24701 14.7915L6.53547 12.6842C6.26108 12.0655 6.1212 11.3956 6.12508 10.7188C6.12424 10.0664 6.25216 9.42027 6.5015 8.81743C6.75084 8.21459 7.1167 7.66689 7.5781 7.20571C8.03973 6.74398 8.58784 6.37775 9.19109 6.12797C9.79435 5.87819 10.4409 5.74975 11.0938 5.75C12.4124 5.75009 13.6769 6.27368 14.6096 7.20571C15.0707 7.66707 15.4364 8.2148 15.6858 8.8176C15.9351 9.4204 16.0631 10.0664 16.0626 10.7188Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.0625 8.27844H11.066" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div style={{width:"94%"}}>
                  <p className="font-weight-600 fs-15">Face Scanned Successfully</p>
                  <p className="font-weight-400 fs-10" style={{lineHeight:"12px"}}>Note - The Scanned Face & your details will be saved as logs for authentication purposes.</p>
                </div>
              </div>
            )
          } */}
          {/* {
            props.type == "Gym Attendance" ? ( */}
              <div className="d-flex w-full m-t-20 space-between">
                <div onClick={!isButtonLock ?()=>MarkWorkoutPlusAttendance():null} className={`member-button-global ${isButtonLock && `member-button-global-inactive`} btn-center w-full d-flex flex-item bg-dark-blue fadeIn`} style={{transition:"180ms"}}>
                  <p className='flex-item p-l-12 p-r-12' style={{color:"#ffffff"}}>Mark Attendance </p>
                </div>
              </div>
            {/* ) : (
              <div className="d-flex w-full m-t-20 space-between">
                <div onClick={!isButtonLock ?()=> verifyOtp():null} className={`member-button-global ${isButtonLock && `member-button-global-inactive`} w-full d-flex ${isButtonLock ? 'space-between':'btn-center'} bg-dark-blue fadeIn`} style={{transition:"180ms"}}>
                  <p className={`flex-item ${isButtonLock && `p-l-12 p-r-12`}`} style={{color:"#ffffff", lineHeight:"14px"}}>Mark Attendance</p>
                  {
                    isButtonLock && (
                      <svg className="flex-item" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.616 21C6.168 21 5.78667 20.8427 5.472 20.528C5.15733 20.2133 5 19.8323 5 19.385V10.615C5 10.1683 5.15733 9.78733 5.472 9.472C5.78667 9.15733 6.168 9 6.616 9H8V7C8 5.886 8.38833 4.941 9.165 4.165C9.941 3.38833 10.886 3 12 3C13.114 3 14.0593 3.38833 14.836 4.165C15.6127 4.94167 16.0007 5.88667 16 7V9H17.385C17.8317 9 18.2127 9.15733 18.528 9.472C18.8427 9.78667 19 10.168 19 10.616V19.385C19 19.8317 18.8427 20.2127 18.528 20.528C18.2133 20.8427 17.8323 21 17.385 21H6.616ZM6.616 20H17.385C17.5643 20 17.7117 19.9423 17.827 19.827C17.9423 19.7117 18 19.5643 18 19.385V10.615C18 10.4357 17.9423 10.2883 17.827 10.173C17.7117 10.0577 17.5643 10 17.385 10H6.615C6.43567 10 6.28833 10.0577 6.173 10.173C6.05767 10.2883 6 10.436 6 10.616V19.385C6 19.5643 6.05767 19.7117 6.173 19.827C6.28833 19.9423 6.436 20 6.616 20ZM12 16.5C12.422 16.5 12.7773 16.3553 13.066 16.066C13.3553 15.7773 13.5 15.422 13.5 15C13.5 14.578 13.3553 14.2227 13.066 13.934C12.7767 13.6453 12.4213 13.5007 12 13.5C11.5787 13.4993 11.2233 13.644 10.934 13.934C10.6447 14.2227 10.5 14.578 10.5 15C10.5 15.422 10.6447 15.7773 10.934 16.066C11.2227 16.3553 11.578 16.5 12 16.5ZM9 9H15V7C15 6.16667 14.7083 5.45833 14.125 4.875C13.5417 4.29167 12.8333 4 12 4C11.1667 4 10.4583 4.29167 9.875 4.875C9.29167 5.45833 9 6.16667 9 7V9Z" fill="black"/>
                      </svg>
                    )
                  }
                </div>
              </div>
            )
          } */}
        </div>
      </div>
  </div>
  )
}

export default Attendance;